"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { tbClearQuickFilters } from "Actions/Table/TableToolBarActions";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";

var ClearQuickFiltersButtonProp =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(ClearQuickFiltersButtonProp, _BaseToolbarButtonPro);

  function ClearQuickFiltersButtonProp(_ref) {
    var _this;

    var formID = _ref.formID,
        formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        rest = _objectWithoutProperties(_ref, ["formID", "formUUID", "isContextMenu"]);

    _classCallCheck(this, ClearQuickFiltersButtonProp);

    var props = _objectSpread({
      elementAttr: {
        'class': "clear-quick-filter"
      },
      text: Messages.Controls.ClearQuickFilters,
      hint: Messages.Controls.ClearQuickFilters,
      disabled: true,
      onClick: function onClick(e) {
        _this.UUID = _this._isContextMenu ? _this._props.UUID : _this._props.options.UUID;
        tbClearQuickFilters({
          formUUID: _this.UUID,
          formID: formID
        });
      },
      iconType: 'material2:mdi mdi-filter-remove',
      isContextMenu: isContextMenu
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClearQuickFiltersButtonProp).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;
    return _this;
  }

  return ClearQuickFiltersButtonProp;
}(BaseToolbarButtonProp);

_defineProperty(ClearQuickFiltersButtonProp, "create", function (options) {
  return new ClearQuickFiltersButtonProp(options).props();
});

export { ClearQuickFiltersButtonProp as default };